import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import ExpansionPanel from '@/views/components/ExpansionPanel.vue';
import AlertCard from '@/views/components/AlertCard.vue';
import { mdiFilterVariant } from '@mdi/js';
import FiltroOrdenacao from '@/views/components/FiltroOrdenacao.vue';
import SeletorOpcoesImpressão from '@/views/components/SeletorOpcoesImpressão.vue';
import CardResultado from './CardResultado.vue';
import { ConsultaJurisprudenciaSelecionadaStore } from '../../store/ConsultaJurisprudenciaSelecionadaStore';
import { storeToRefs } from 'pinia';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import IconTextoNorma from '@/views/components/icons/IconTextoNorma.vue';
import { contemNaLista, toggleSelecionado } from '@/utils/ListUtils';
import { isTodosSelecionados, selecionarTodos } from '@/utils/ListUtils';

export default /*#__PURE__*/_defineComponent({
  __name: 'ResultadoConsulta',
  setup(__props) {

const store = ConsultaJurisprudenciaSelecionadaStore();

const {
  pageSubfiltros,
  jurisprudencias,
  totalElementos,
  pagina,
  jurisprudenciasSelecionadas,
  totalHits,
  filtroJurisprudencia,
} = storeToRefs(store);

const { consultaJurisprudenciaSelecionada } = store;

const resultadoConsulta = ref();

const { download } = store;

const itensImpressao = [
  {
    text: 'Acórdãos',
    value: 'A',
    icone: IconTextoNorma,
  },
  {
    text: 'Simplificado',
    value: 'S',
    icone: IconPaginaSimplificada,
  },
  {
    text: 'Detalhado',
    value: 'D',
    icone: IconPaginaDetalhada,
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const atualizarOrdenacao = async (ordenacao: any) => {
  ordenacaoSelecionada.value = ordenacao;
  filtroJurisprudencia.value.ordenacao = ordenacao.value;
  await consultaJurisprudenciaSelecionada();
};

const ordenacao = [
  {
    text: 'Data de julgamento decrescente',
    value: 'dtjulgamento desc',
  },
  { text: 'Data de julgamento crescente', value: 'dtjulgamento asc' },
  { text: 'Relevância', value: 'deRelevancia' },
];

const ordenacaoSelecionada = ref({
  text: 'Data de julgamento decrescente',
  value: 'dtjulgamento desc',
});

const desabilitarImpressao = computed(() => {
  return jurisprudenciasSelecionadas.value?.length < 1;
});

const consulta = () => {
  pagina.value = 1;
  consultaJurisprudenciaSelecionada();
};

const atualizarPaginacao = async () => {
  resultadoConsulta.value.scrollIntoView({ behavior: 'smooth' });
  await consultaJurisprudenciaSelecionada();
};

const limparFiltrosResultado = () => {
  pageSubfiltros.value?.forEach((filtro) =>
    filtro?.valoresSubFiltroResponseDTO?.forEach(
      (subFiltro) => (subFiltro.checked = false)
    )
  );
};

return { __sfc: true,store, pageSubfiltros, jurisprudencias, totalElementos, pagina, jurisprudenciasSelecionadas, totalHits, filtroJurisprudencia, consultaJurisprudenciaSelecionada, resultadoConsulta, download, itensImpressao, atualizarOrdenacao, ordenacao, ordenacaoSelecionada, desabilitarImpressao, consulta, atualizarPaginacao, limparFiltrosResultado, ExpansionPanel, AlertCard, mdiFilterVariant, FiltroOrdenacao, SeletorOpcoesImpressão, CardResultado, contemNaLista, toggleSelecionado, isTodosSelecionados, selecionarTodos }
}

})